import React, { useState, useEffect, useRef } from 'react';
import { Text, View, Image, StyleSheet, Pressable, TextInput } from 'react-native';

import { refreshOrder } from '../../utils/services/oms/OMSUtils';
import { windowRedirectToRazorpay } from '../../utils/services/webapp-services/windowsInternalFunction';

import { CommonCTA, PrimaryCTA } from '../../utils/widgets/CommonCTA';
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";

import { msgType, paymentModes } from '../../utils/constants/ConstantsMapping';
import { NavigateFrom, ScreenRoute } from '../../utils/constants/ScreenRouteConstant';
import { EntityTypePharmacy, IndiaRupee, ServiceName } from '../../utils/constants/AppConstants';

import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';
import ToastModal from '../../utils/modals/ToastModal';

import BottomSheetModal from '../../utils/modals/CommonBottomSheet';

import Colors from '../../utils/constants/AppColors';
import ModalContent from '../../utils/constants/ModalContentConstant';

import * as API from '../../utils/services/api/API';
import * as OMSAPI from '../../utils/services/api/OMSAPI'
import * as CommonUtils from '../../utils/services/CommonUtils';
import * as AlertService from "../../utils/services/AlertLoaderService";

const CustomCheckout = (props) => {

    const [showCODConfirmationModal, setCODModal] = useState(false)
    const [upiPaymentsModes, setUpiPaymentsModes]: any = useState([]);
    const [netBankingModes, setNetBankingModes]: any = useState([]);
    const [walletModes, setWalletModes]: any = useState([]);
    const [confirmCod, setConfirmCod]: any = useState(false);

    const [serviceCharges, updateServiceCharges]: any = useState(props.route?.params?.serviceCharges);
    const [vpaAddress, setVpaAddress]: any = useState('');
    const [vpaUserName, setVpaUserName]: any = useState(null);
    const [isValidVpa, setIsValidVpa]: any = useState(null);
    const [isVpaInputVisible, setIsVpaInputVisible]: any = useState(false);
    const [isShowInvalidVpaMesg, SetIsShowInvalidVpaMesg]: any = useState(false);
    const [selectedMode, setSelectedMode]: any = useState({});
    const [isVpaInputValid, setIsVpaInputValid]: any = useState(false);
    const [serviceTokenV2, updateserviceTokenV2] = useState(props.route?.params?.serviceTokenV2);
    const [serviceName, setServiceName] = useState(props.route?.params?.serviceName);
    const [orderDetails, setOrderDetails] = useState(props.route?.params?.orderDetails);
    const [pharmacyDetails, setPharmacyDetails] = useState(props.route?.params?.pharmacyDetails);

    const [toastData, setToastData] = useState({
        showToast: false, text: ''
    })

    let confirmOrderViewRef: any = useRef();

    var staticData: { [x: string]: any; };


    const tpUpiAppHandlesList = ['rmhdfcbank', 'abfspay', 'fbl', 'axisb', 'okaxis', 'okhdfcbank', 'okicici', 'oksbi', 'hdfcbankjd',
        'myicici', 'ikwik', 'ybl', 'ibl', 'axl', 'pingpay', 'idfcbank', 'icici', 'waaxis', 'wahdfcbank',
        'wasbi', 'apl', 'yesbank', 'hsbc', 'timecosmos', 'jupiteraxis', 'paytm', 'kmbl', 'upi', 'indus', 'kbl', 'fbpe', 'okbizaxis']

    function confirmVpaAddress() {
        AlertService.loaderModal.setLoader(true);
        API.doPost('v2207/payment/validate_vpa', { vpa: vpaAddress, pwa: true }).then(
            (response: any) => {
                if (response['valid']) {
                    setVpaUserName()
                    AlertService.loaderModal.setLoader(false);
                    setIsValidVpa(true);
                    SetIsShowInvalidVpaMesg(true);
                    setVpaUserName(response['registeredCustomerName']);
                } else {
                    setIsValidVpa(false);
                    SetIsShowInvalidVpaMesg(true);
                    AlertService.loaderModal.setLoader(false);
                }
            })

    }

    function updateModeAndUpiInput(item) {
        setSelectedMode(item);
        setConfirmCod(false);
        getPayableAmount(false);
        if (item.mode === 'upi') {
            setIsVpaInputVisible(true)
            SetIsShowInvalidVpaMesg(false)
            setIsValidVpa(false);
            setVpaAddress('');
        } else {
            setIsVpaInputVisible(false)
            SetIsShowInvalidVpaMesg(false)
            makeOnlinePayment(item);
        }
    }

    const setCODConfirmationModal = () => {
        setCODModal(true)
    }

    const closeCODConfirmationModal = () => {
        setCODModal(false)
    }

    useEffect(() => {
        if (global.paymentModesList || localStorage.getItem('paymentModesList')) {
            const paymentModesList = global.paymentModesList || JSON.parse(localStorage.getItem('paymentModesList'));
            setUpiPaymentsModes(paymentModesList.filter((item) => item.sid === 'upi'));
            setNetBankingModes(paymentModesList.filter((item) => item.sid === 'netbanking'));
            setWalletModes(paymentModesList.filter((item) => item.sid === 'wallet'))
            localStorage.setItem('netBankingModes', JSON.stringify(paymentModesList.filter((item) => item.sid === 'netbanking')))
            localStorage.setItem('walletModes', JSON.stringify(paymentModesList.filter((item) => item.sid === 'wallet')))
        }
    }, []);

    const modesListView = (paymentModeList, modesVisible = 0, upiMode: any = null) => {
        return <View style={AppStyles.flexRow}>
            {paymentModeList.slice(0, modesVisible ? modesVisible : paymentModeList.length).map((item, index) => (
                <Pressable onPress={() => { updateModeAndUpiInput(item) }} style={[styles.payamentIcon]}
                    onLongPress={() => { console.log('### long press') }}>
                    <Image source={{ uri: item?.icon ? item.icon : CommonUtils.getImagePath(`/images/oms/rops/icons/${item.service}.svg`) }} style={[styles.modeIcon, { borderWidth: item.icon === null ? 0 : 3 }]} />
                    <View style={[TextStyle.text12, { marginTop: 4, fontStyle: 'normal', fontFamily: 'Roboto_400Regular' }]} key={index}>{item['endn']}</View></Pressable>
            ))}

            {upiMode == 'wallet' && <Pressable onPress={() => { setConfirmCod(false); props.navigation.navigate(ScreenRoute.wallet_netbanking_mods_list, { payableAmount: getPayableAmount(false), walletModes: walletModes, makeOnlinePayment: makeOnlinePayment }) }}
                style={styles.payamentIcon} onLongPress={() => null}>
                <Image source={{ uri: CommonUtils.getImagePath('/images/oms/rops/view_more_modes.svg') }} style={[styles.modeIcon]} />
                <Text style={[TextStyle.text12, { color: AppTheme.color.blue.toggleColor1, paddingTop: 4 }]}>View all</Text></Pressable>}

            {upiMode == 'netbanking' && <Pressable onPress={() => { setConfirmCod(false); props.navigation.navigate(ScreenRoute.wallet_netbanking_mods_list, { netBankingModes: netBankingModes, makeOnlinePayment: makeOnlinePayment }) }}
                style={{ display: 'flex', alignItems: 'center', paddingRight: 20, marginBottom: 4 }} onLongPress={() => null}>
                <Image source={{ uri: CommonUtils.getImagePath('/images/oms/rops/view_more_modes.svg') }} style={[styles.modeIcon]} />
                <Text style={[TextStyle.text12, { color: AppTheme.color.blue.toggleColor1, paddingTop: 4 }]}>View all</Text></Pressable>}
        </View>
    }

    const makeOnlinePayment = (modeItem) => {
        setConfirmCod(false);
        getPayableAmount(false);
        doPayment(modeItem);
    }

    const resetPaymentDetails = () => {
        setIsVpaInputVisible(false)
        SetIsShowInvalidVpaMesg(false)
        setIsValidVpa(false);
        setVpaAddress('');
    }

    const toggleCashOnDeliveryCta = () => {
        resetPaymentDetails();
        setTimeout(() => {
            confirmOrderViewRef?.current?.scrollIntoView()
        }, 100);
    }

    function getPayableAmount(cod) {
        if (!props.route.params) { return -1; }
        if (serviceName == ServiceName.order) {
            if (cod) return serviceCharges['orderDeliveryChargeAmount'] + serviceCharges['orderPayableAmount']
            else return serviceCharges['payableAmount']
        }
        else return serviceCharges['payableAmount'] - serviceCharges['usableBalance'];
    }

    const checkIfGPaySupported = (paymentData) => {
        let isGPayAvailable = false
        window['checkIfGPaySupported'](paymentData, (gapyAvailable) => {
            isGPayAvailable = gapyAvailable;
        });
        return isGPayAvailable
    }

    return (
        <View style={{ flex: 1, width: AppTheme.appWidth, height: '100%', minHeight: '100vh' }}>
            <CommonHeader navigation={props.navigation} allowPopScreen={true} title={`To Pay: ${IndiaRupee}${getPayableAmount(confirmCod)}`}></CommonHeader>

            <View style={{ margin: 16, marginTop: AppTheme.headerHeight, paddingTop: 17 }}>

                <Text style={styles.modesTitle}>UPI Payments</Text>
                <View>{modesListView(upiPaymentsModes)}</View>

                {isVpaInputVisible && <View style={{ paddingTop: 16 }}>
                    <View>
                        <View style={AppStyles.flexRowSpaceBetween}>
                            <TextInput
                                style={[styles.grayText, TextStyle.text14, styles.vpaInput, { borderColor: '#4F4F4F' }]}
                                placeholderTextColor={AppTheme.color.fillerInfo}
                                placeholder={`Enter your ${selectedMode['endn']} UPI ID`}
                                underlineColorAndroid="transparent"
                                maxLength={80}
                                value={vpaAddress}
                                onChangeText={(text) => { setIsValidVpa(false); SetIsShowInvalidVpaMesg(false); setVpaAddress(text); text.length > 3 && (tpUpiAppHandlesList.includes(text.split('@')[1])) ? setIsVpaInputValid(true) : setIsVpaInputValid(false) }} />
                            <Text onPress={() => { isValidVpa ? makeOnlinePayment({ ...selectedMode, vpa: vpaAddress }) : confirmVpaAddress() }}
                                style={[TextStyle.text14, isVpaInputValid ? styles.applyActiveBtn : styles.disabledBtn, { textAlign: 'center' }]}>
                                {isValidVpa ? 'Pay' : 'Confirm'}</Text>
                        </View>
                        {isShowInvalidVpaMesg && <View style={{ paddingTop: 4 }}> {isValidVpa ? <View style={AppStyles.flexRow}> <Text style={[TextStyle.text12, { color: '#4F4F4F' }]}>{`${vpaUserName} `}</Text> <Image resizeMode='contain' source={{ uri: CommonUtils.getImagePath('/images/oms/rops/checked_cod.svg') }} style={{ width: 14, height: 14, }} /></View> : <Text style={[TextStyle.text12, { color: '#rgba(237, 50, 59, 1)', }]}>Invalid Upi Id</Text>}  </View>}
                    </View>
                </View>}

                <View style={styles.hr} ></View>

                <Text style={styles.modesTitle}>Net Banking</Text>
                <View>{modesListView(netBankingModes, 3, 'netbanking')}</View>
                {serviceName == ServiceName.order ? <View style={styles.hr} ></View> : null}

                {serviceName == ServiceName.order ? <View>
                    <Text style={styles.modesTitle}>Pay on delivery</Text>

                    <View style={[AppStyles.flexRowStart, { alignItems: "flex-start" }]}>
                        <Image resizeMode='contain' source={{ uri: CommonUtils.getImagePath('/images/oms/cod-icon.svg') }}
                            style={{ width: 24, height: 24, }} />
                        <View style={{ marginHorizontal: 8, width: AppTheme.appWidth - 90 }}>
                            <Text style={styles.subTitle}>Cash On Delivery (To Pay:  {IndiaRupee}{getPayableAmount(true)})</Text>
                            <Text style={[TextStyle.text12, { color: Colors.grey.text, flexWrap: "wrap" }]}>
                                We suggest you make online payments to avail offers & sehat sikke.</Text>
                        </View>
                        <Pressable onPress={() => {
                            setConfirmCod(!confirmCod);
                            toggleCashOnDeliveryCta()
                        }}>
                            {
                                confirmCod ?
                                    <Image resizeMode='contain'
                                        source={{
                                            uri: CommonUtils.getImagePath(
                                                '/images/oms/rops/checked_cod.svg')
                                        }} style={{ width: 18, height: 18, }} /> :
                                    <View style={{
                                        height: 18,
                                        width: 18,
                                        borderRadius: 50,
                                        borderColor: 'rgba(0, 0, 0, 0.38)', borderWidth: 1
                                    }} />
                            }

                        </Pressable>

                    </View>

                    {confirmCod && <View ref={confirmOrderViewRef}
                        style={[AppStyles.submitBtn, {
                            bottom: 20, marginTop: 40
                        }]}><PrimaryCTA
                            title={'Confirm'}
                            marginVertical={24}
                            action={() => setCODConfirmationModal()} />
                    </View>}
                </View> : null}
            </View>

            <BottomSheetModal showModal={showCODConfirmationModal}
                modalData={{
                    ...ModalContent.CashOnDelivery,
                    title: ModalContent.CashOnDelivery.title + getPayableAmount(true)
                }} closeModal={closeCODConfirmationModal}
                primaryAction={() => setConfirmCod(false)}
                secondaryAction={cashOnDelivery}
                hasSecondaryCTA={true} />

            <ToastModal showToast={toastData['showToast']}
                setToast={(toastData: any) => { setToastData(toastData) }}
                text={toastData['text']} />

        </View >
    )

    function doPayment(modeItem) {
        AlertService.loaderModal.setLoader(true)
        const reqParam = {
            service: modeItem['service'],
            serviceTokenV2: serviceTokenV2,
            amount: getPayableAmount(false),
            paymentGateway: paymentModes.razorpay,
            // Extra params
            // nodalAccountTransaction: true,
            // signingExtras: serviceName == 'Order Medicine' ? { serviceName: serviceName.OrderMedicine, serviceId: orderDetails['oid'] } : null,
            tpPaymentService: modeItem.service ?? 'card',
            tpPaymentMode: modeItem.mode,
            useAayuCash: serviceName == 'Order Medicine' ? false : true,
            // vpa: modeItem['vpa'],
            pwa: true,
        }

        console.log('###, here, ', reqParam)
        API.doPost('v2207/payment/prepare_for_online_payment', reqParam).then(
            (response: any) => {
                AlertService.loaderModal.setLoader(false)
                if (response && response['gatewayPaymentData'] && response['gatewayPaymentData']['signedPaymentToken']) {
                    var paymentData: any = {
                        amount: response['gatewayPaymentData']['amount'], //pass in paise (amount: 100000 equals ₹1000)
                        method: reqParam['tpPaymentMode'],
                        contact: response['gatewayPaymentData']['phoneNumber'],  // customer's mobile number
                        pgKeyId: response['gatewayPaymentData']['pgKeyId'],
                        order_id: response['gatewayPaymentData']['paymentOrderId'],//..  and other payment parameters, as usual
                        email: response['gatewayPaymentData']['emailId'],
                    };
                    if (reqParam['tpPaymentService'] == 'gpay' &&
                        !!checkIfGPaySupported(JSON.stringify(paymentData))) {
                        paymentData['gpay'] = true;
                        paymentData['vpa'] = modeItem['vpa'];
                    } else if (reqParam['tpPaymentMode'] == 'upi') {
                        paymentData['upi'] = {
                            vpa: modeItem['vpa'],
                            flow: 'collect'
                        }
                    }

                    if (reqParam['tpPaymentMode'] == 'wallet') {
                        paymentData['wallet'] = reqParam['service'];
                    }

                    if (reqParam['tpPaymentMode'] == 'card') {
                        paymentData['card'] = modeItem
                        delete paymentData['card']['method'];
                        delete paymentData['card']['mode'];
                        delete paymentData['method']
                    }

                    if (reqParam['tpPaymentMode'] == 'netbanking') {
                        paymentData['bank'] = reqParam['service'];
                    }

                    staticData = {
                        signedPaymentToken: response['gatewayPaymentData']['signedPaymentToken'],
                        razorpayOrderId: response['gatewayPaymentData']['paymentOrderId'],
                    }
                    windowRedirectToRazorpay(paymentData, onPaymentCompletion)
                }
            }).catch((err) => AlertService.loaderModal.setLoader(false)
            )
    }

    function onPaymentCompletion(data) {
        var paymentCBData = JSON.parse(data);
        paymentCBData['signedPaymentToken'] = staticData['signedPaymentToken'];
        AlertService.loaderModal.setLoader(true)
        API.doPost('payment/complete_wallet_recharge', paymentCBData).then((response) => {
            if (response) {
                AlertService.loaderModal.setLoader(false);

                if (serviceName == ServiceName.order) {
                    props.navigation.navigate(ScreenRoute.payment_success_failed, {
                        isPaymentSuccess: true, RedirectOnPaymentSuccess: RedirectOnPaymentSuccess
                    })
                } else {
                    props.route.params?.onPaymentSuccessFromCustomCheckout(true)
                }
            } else {
                AlertService.loaderModal.setLoader(false);
                if (serviceName !== ServiceName.order)
                    props.route.params?.onPaymentSuccessFromCustomCheckout(false)

                props.navigation.navigate(ScreenRoute.payment_success_failed, {
                    isPaymentSuccess: false
                })
            }
        }).catch((err) => {
            setToastData({ showToast: true, text: err['msg'] })
            AlertService.loaderModal.setLoader(false);
        })
    }


    function cashOnDelivery() {
        AlertService.loaderModal.setLoader(true)
        const payload = {
            payableAmount: pharmacyDetails['offer']['payableAmount'],
            estDelTime: orderDetails['estDelTime']
        }
        const params = {
            msgData: {
                msgType: msgType.OFFER_ACCEPTED,
                targetType: EntityTypePharmacy,
                payload: JSON.stringify(payload),
                targetId: pharmacyDetails['id'],
            },
            orderId: orderDetails['oid'],
            pid: pharmacyDetails['id']
        }
        OMSAPI.doPost('order/message/send', params).then(
            (response: any) => {
                AlertService.loaderModal.setLoader(false);
                RedirectOnPaymentSuccess()
            }, (err: any) => { console.log("API is failed with error " + err) }
        )
    }


    function RedirectOnPaymentSuccess() {
        refreshOrder()
        global.navigateFrom = NavigateFrom.oms_message_view + ',' + orderDetails['oid'] + ',' + props.route.params?.['pid'];
        if (props.navigation.canGoBack())
            props.navigation.popToTop();
        props.navigation.replace(ScreenRoute.orders);
    }
}

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    vpaInput: { flexGrow: 1, borderWidth: 1, borderRadius: 8, padding: 8, marginRight: 8, paddingVertical: 16, width: AppTheme.appWidth, paddingHorizontal: 16, color: 'black', },
    disabledBtn: {
        width: 87, borderRadius: 12, padding: 16, gap: 10, backgroundColor: 'rgba(0, 0, 0, 0.38)'
    },
    applyActiveBtn: {
        width: 87, borderRadius: 12, padding: 16, gap: 10, color: 'white', backgroundColor: AppTheme.color.primary
    },
    modeIcon: { width: 38, height: 38, borderColor: AppTheme.color.primary, borderRadius: 50 },
    payamentIcon: { display: 'flex', alignItems: 'center', paddingRight: 20, marginBottom: 4 },

    container: {
        flex: 1,
    },
    hr: {
        backgroundColor: 'rgba(235, 235, 235, 1)',
        height: 2,
        position: 'relative',
        left: -17,
        width: AppTheme.appWidth,
        marginVertical: 16
    },
    subTitle: {
        fontWeight: 600,
        fontSize: 14,
        lineHeight: 16,
        color: '#000000',
        paddingBottom: 5
    },
    modesTitle: {
        fontSize: 16,
        fontWeight: '700',
        lineHeight: 19,
        letterSpacing: 0,
        textAlign: 'left',
        paddingBottom: 16

    },
    checkbox: {
        // alignSelf: "center",
        margin: 10,
        // backgroundColor: AppTheme.color.primary,
        height: 18,
        width: 18,
        borderWidth: 1,
        borderColor: 'rgba(0, 0, 0, 0.38)'
    },

    grayText: {
        fontSize: 12,
        color: '#4F4F4F'
    },


}))

export default CustomCheckout;